<form
  [formGroup]="emergencyContactsForm"
  (keydown.enter)="enter($event)"
  [ngClass]="{ submitted: formSubmitted }"
  >
  @for (contact of contacts.controls; track contact; let i = $index) {
    <div
      formArrayName="contacts"
      >
      <div [formGroupName]="i">
        <h3>
          {{ "Emergency Contact" | translate }} {{ i + 1 }}
          @if (i == 0) {
            <span>- {{ "Admission Mediator" | translate }}</span>
          }
        </h3>
        <div>
          <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
            <div
              fxLayout="col"
              fxFlex="35"
              class="add-patient-col"
              fxLayoutAlign="start center"
              >
              {{ "First Name" | translate }}
            </div>
            <div
              fxLayout="col"
              fxFlex="35"
              class="add-patient-col"
              fxLayoutAlign="start center"
              >
              {{ "Last Name" | translate }}
            </div>
            <div
              fxLayout="col"
              fxFlex="30"
              class="add-patient-col"
              fxLayoutAlign="start center"
              >
              {{ "Relationship with patient" | translate
              }}<span class="optional">{{ "(optional)" | translate }}</span>
            </div>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="add-patient-row"
            >
            <div fxLayout="col" fxFlex="35" class="add-patient-col">
              <input
                type="text"
                class="add-patient-input"
                formControlName="firstName"
                [placeholder]="'First Name' | translate"
                [maxLength]="51"
                pattern="[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]*"
                onkeypress="return /^[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]+$/i.test(event.key)"
                required
                />
              </div>
              <div fxLayout="col" fxFlex="35" class="add-patient-col">
                <input
                  type="text"
                  class="add-patient-input"
                  formControlName="lastName"
                  [placeholder]="'Last Name' | translate"
                  [maxLength]="51"
                  pattern="[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]*"
                  onkeypress="return /^[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]+$/i.test(event.key)"
                  required
                  />
                </div>
                <div fxLayout="col" fxFlex="30" class="add-patient-col">
                  <nz-select
              (keydown.enter)="
                $event.stopPropagation(); $event.preventDefault()
              "
                    class="add-patient-inputZorro"
                    nzShowSearch
                    nzAllowClear
                    formControlName="closestRelativeId"
                    [nzPlaceHolder]="'Relationship with patient' | translate"
                    >
                    @for (relative of closestRelativesList; track relative) {
                      <nz-option
                        [nzLabel]="relative.name"
                        [nzValue]="relative.id"
                      ></nz-option>
                    }
                  </nz-select>
                  <!--
                  Conditionally show the free text input.
                  The number 7 is the id of option "Other" in closest relatives
                  -->
                  @if (contact.get('closestRelativeId')?.value == 7) {
                    <input
                      class="add-patient-input"
                      formControlName="closestRelativeOther"
                      placeholder="{{ 'Please specify' | translate }}"
                      [maxLength]="50"
                      />
                  }
                </div>
              </div>
            </div>
            <div>
              <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                <div
                  fxLayout="col"
                  fxFlex="50"
                  class="add-patient-col"
                  fxLayoutAlign="start center"
                  >
                  {{ "Occupation" | translate
                  }}<span class="optional">{{ "(optional)" | translate }}</span>
                </div>
                <div
                  fxLayout="col"
                  fxFlex="50"
                  class="add-patient-col"
                  fxLayoutAlign="start center"
                  >
                  {{ "Phone number" | translate }}
                </div>
                <div
                  fxLayout="col"
                  fxFlex="50"
                  class="add-patient-col"
                  fxLayoutAlign="start center"
                  >
                  {{ "Email" | translate
                  }}<span class="optional">{{ "(optional)" | translate }}</span>
                </div>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="center center"
                class="add-patient-row"
                >
                <div fxLayout="col" fxFlex="50" class="add-patient-col">
                  <input
                    class="add-patient-input"
                    [placeholder]="'Occupation' | translate"
                    formControlName="occupation"
                    [maxLength]="101"
                    />
                  </div>
                  <div fxLayout="col" fxFlex="50" class="add-patient-col">
                    <ngx-intl-tel-input
                      [cssClass]="'custom'"
                      [preferredCountries]="[CountryISO.Cyprus, CountryISO.Greece]"
                      [enableAutoCountrySelect]="false"
                      [enablePlaceholder]="false"
                      [searchCountryFlag]="true"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name
              ]"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.Cyprus"
                      [maxLength]="16"
                      [phoneValidation]="true"
                      [separateDialCode]="true"
                      name="phone"
                      formControlName="phoneNumber"
                    ></ngx-intl-tel-input>
                  </div>
                  <div fxLayout="col" fxFlex="50" class="add-patient-col">
                    <input
                      class="add-patient-input"
                      [placeholder]="'Email' | translate"
                      formControlName="email"
                      [maxLength]="51"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                    <div
                      fxLayout="col"
                      fxFlex="50"
                      class="add-patient-col"
                      fxLayoutAlign="start center"
                      >
                      {{ "Identifier Type" | translate
                      }}<span class="optional">{{ "(optional)" | translate }}</span>
                    </div>
                    <div
                      fxLayout="col"
                      fxFlex="50"
                      class="add-patient-col"
                      fxLayoutAlign="start center"
                      >
                      {{ "Identifier" | translate
                      }}<span class="optional">{{ "(optional)" | translate }}</span>
                    </div>
                  </div>
                  <div
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    class="add-patient-row"
                    >
                    <div fxLayout="col" fxFlex="50" class="add-patient-col">
                      <nz-select
              (keydown.enter)="
                $event.stopPropagation(); $event.preventDefault()
              "
                        class="add-patient-inputZorro"
                        nzShowSearch
                        nzAllowClear
                        [nzPlaceHolder]="'Identifier Type' | translate"
                        formControlName="identifierType"
                        (ngModelChange)="onIdentifierTypeChange($event, i)"
                        >
                        <nz-option
                          [nzLabel]="'National ID' | translate"
                          nzValue="nationalId"
                        ></nz-option>
                        <nz-option
                          [nzLabel]="'Passport' | translate"
                          nzValue="passport"
                        ></nz-option>
                        <nz-option
                          [nzLabel]="'Alien Resident Card' | translate"
                          nzValue="arc"
                        ></nz-option>
                      </nz-select>
                    </div>
                    <div fxLayout="col" fxFlex="50" class="add-patient-col">
                      <input
                        class="add-patient-input"
                        [placeholder]="'Identifier' | translate"
                        formControlName="identifier"
                        />
                        @if (contact.get('identifierType')?.value !== 'arc') {
                          <nz-select
              (keydown.enter)="
                $event.stopPropagation(); $event.preventDefault()
              "
                            class="add-patient-inputZorro"
                            nzShowSearch
                            nzAllowClear
                            [nzPlaceHolder]="'Issuing Country' | translate"
                            formControlName="identifierCountry"
                            >
                            @for (country of countriesList; track country) {
                              <nz-option
                                nzLabel="{{ country.name }}"
                                nzValue="{{ country.id }}"
                              ></nz-option>
                            }
                          </nz-select>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- Emergency Contact's Address data  -->
                  <div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                      <div
                        fxLayout="col"
                        fxFlex="100"
                        class="add-patient-col"
                        fxLayoutAlign="start center"
                        >
                        {{ "Street" | translate }}
                        <span class="optional">{{ "(optional)" | translate }}</span>
                      </div>
                    </div>
                    <div
                      fxLayout="row"
                      fxLayoutAlign="center center"
                      class="add-patient-row"
                      >
                      <div fxLayout="col" fxFlex="100" class="add-patient-col">
                        <input
                          class="add-patient-input"
                          [placeholder]="'Street' | translate"
                          formControlName="street"
                          [maxLength]="51"
                          />
                        </div>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                        <div
                          fxLayout="col"
                          fxFlex="33"
                          class="add-patient-col"
                          fxLayoutAlign="start center"
                          >
                          {{ "Street Number" | translate }}
                          <span class="optional">{{ "(optional)" | translate }}</span>
                        </div>
                        <div
                          fxLayout="col"
                          fxFlex="33"
                          class="add-patient-col"
                          fxLayoutAlign="start center"
                          >
                          {{ "Apartment Number" | translate
                          }}<span class="optional">{{ "(optional)" | translate }}</span>
                        </div>
                        <div
                          fxLayout="col"
                          fxFlex="33"
                          class="add-patient-col"
                          fxLayoutAlign="start center"
                          >
                          {{ "Postcode" | translate }}
                          <span class="optional">{{ "(optional)" | translate }}</span>
                        </div>
                      </div>
                      <div
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        class="add-patient-row"
                        >
                        <div fxLayout="col" fxFlex="33" class="add-patient-col">
                          <input
                            class="add-patient-input"
                            [placeholder]="'Street Number' | translate"
                            formControlName="streetNumber"
                            [maxLength]="31"
                            />
                          </div>
                          <div fxLayout="col" fxFlex="33" class="add-patient-col">
                            <input
                              class="add-patient-input"
                              [placeholder]="'Apartment Number' | translate"
                              formControlName="apartmentNumber"
                              [maxLength]="31"
                              />
                            </div>
                            <div fxLayout="col" fxFlex="33" class="add-patient-col">
                              <input
                                class="add-patient-input"
                                [placeholder]="'Postcode' | translate"
                                formControlName="postcode"
                                [maxLength]="31"
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                              <div
                                fxLayout="col"
                                fxFlex="33"
                                class="add-patient-col"
                                fxLayoutAlign="start center"
                                >
                                {{ "Country" | translate }}
                                <span class="optional">{{ "(optional)" | translate }}</span>
                              </div>
                              <div
                                fxLayout="col"
                                fxFlex="33"
                                class="add-patient-col"
                                fxLayoutAlign="start center"
                                >
                                {{ "Town" | translate }}
                                <span class="optional">{{ "(optional)" | translate }}</span>
                              </div>
                              <div
                                fxLayout="col"
                                fxFlex="33"
                                class="add-patient-col"
                                fxLayoutAlign="start center"
                                >
                                {{ "District" | translate }}
                                <span class="optional">{{ "(optional)" | translate }}</span>
                              </div>
                            </div>
                            <div
                              fxLayout="row"
                              fxLayoutAlign="center center"
                              class="add-patient-row"
                              >
                              <div fxLayout="col" fxFlex="33" class="add-patient-col">
                                <nz-select
              (keydown.enter)="
                $event.stopPropagation(); $event.preventDefault()
              "
                                  class="add-patient-inputZorro"
                                  nzShowSearch
                                  nzAllowClear
                                  [nzPlaceHolder]="'Country' | translate"
                                  formControlName="country"
                                  (ngModelChange)="onCountryChange($event)"
                                  >
                                  @for (place of countriesList; track place) {
                                    <nz-option
                                      [nzLabel]="place.name"
                                      [nzValue]="place.id"
                                    ></nz-option>
                                  }
                                </nz-select>
                              </div>
                              <div fxLayout="col" fxFlex="33" class="add-patient-col">
                                @if (!isCountryCyprus) {
                                  <input
                                    class="add-patient-input"
                                    [placeholder]="'Town' | translate"
                                    formControlName="town"
                                    [maxLength]="51"
                                    />
                                  } @else {
                                    <nz-select
                (keydown.enter)="
                  $event.stopPropagation(); $event.preventDefault()
                "
                                      class="add-patient-inputZorro"
                                      nzShowSearch
                                      nzAllowClear
                                      [nzPlaceHolder]="'Select a Town' | translate"
                                      formControlName="town"
                                      >
                                      @for (city of cyprusCities; track city) {
                                        <nz-option
                                          [nzLabel]="city | translate"
                                          [nzValue]="city"
                                        ></nz-option>
                                      }
                                    </nz-select>
                                  }
                                  <!-- Dropdown if Cyprus -->
                                </div>
                                <div fxLayout="col" fxFlex="33" class="add-patient-col">
                                  <input
                                    class="add-patient-input"
                                    [placeholder]="'District' | translate"
                                    formControlName="district"
                                    [maxLength]="51"
                                    />
                                  </div>
                                </div>
                              </div>
                              @if (contacts.length > 1) {
                                <button
                                  class="back-button"
                                  (click)="removeEmergencyContact(i)"
                                  type="button"
                                  >
                                  {{ "Remove" | translate }}
                                </button>
                              }
                            </div>
                          </div>
                        }
                        <button
                          class="add-patient-button"
                          (click)="addEmergencyContact()"
                          type="button"
                          >
                          {{ "Add another emergency contact" | translate }}
                        </button>
                      </form>
